import{jsx as t,jsxs as e}from"react/jsx-runtime";import{useUIDSeed as o}from"react-uid";import i from"styled-components";import{getMessageTime as n}from"../../../../../utils/common.js";import{withTranslations as r}from"../../../../../services/translations/withTranslations.js";import{Metadata as a,Wrapper as l,Time as p}from"../styled.js";import{LaunchIcon as d}from"./components/LaunchIcon.js";import{CallIcon as x}from"./components/CallIcon.js";import{TemplateHeaderWhatsApp as s}from"./components/TemplateHeaderWhatsApp.js";import{MarkdownText as c}from"../../../../../components/MarkdownText/MarkdownText.js";const m=i.div`
  display: flex;
  flex-direction: column;
  box-sizing: content-box;

  ${({isFullWidth:t})=>!t&&"align-items: flex-start;"}
  ${({RTLLayout:t})=>t&&"align-items: flex-end;"}
`,f=i.div`
  padding: 7px 0 6px 0;
`,h=i.div`
  color: rgba(0, 0, 0, 0.45);
  font-size: 13px;
`,g=i.div`
  display: flex;
`,u=i.div`
  margin-top: -6px;
  width: calc(85% + 9px);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`,y=i.div`
  width: calc(50% - 2px);
  text-align: center;
  color: #05a4f3;
  background-color: #fff;
  margin: 2px 1px;
  border-radius: 7.5px;
  font-size: 14px;
  padding: 0 16px;
  box-sizing: border-box;
  flex-grow: 1;
  padding: 14px 0;
`,L=i.div`
  border-top: 1px solid #d9dde1;
  margin: 8px 4px -6px 4px;
  padding-top: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
`,b=i.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  color: #05a4f3;
  font-size: 14px;

  svg {
    fill: #05a4f3;
    width: 16px;
  }
`,w=i.p`
  margin: 0 2px;
`,T=i(a)`
  margin: ${({RTLLayout:t})=>t?"0 auto 0 0":"0 0 0 auto"};
`,R={URL:t(d,{}),PHONE_NUMBER:t(x,{}),QUICK_REPLY:null},v=r((({header:i,body:r,footer:a,buttons:d,quickReplies:x,RTLLayout:v,date:j,locale:k,hour12:z})=>{const $=o();return e(m,{isFullWidth:!!x?.length||!!d?.length||"TEXT"!==i?.format,RTLLayout:v,children:[e(l,{"data-test":"template-whatsapp",incoming:!0,RTLLayout:v,children:[t(s,{header:i}),r&&r.text&&r.text.length>0&&t(f,{children:t(c,{text:r.text})}),e(g,{children:[a&&a.text&&a.text.length>0&&t(h,{children:t(c,{text:a.text})}),t(T,{RTLLayout:v,children:t(p,{"data-test":"text-time-whatsapp",children:n(j,z,k)})})]}),d&&d.length>0&&t(L,{children:d.map((({type:o,text:i},n)=>e(b,{children:[R[o],t(w,{children:i})]},$(`button${n}`))))})]}),x&&x.length>0&&t(u,{children:x.map((({text:e},o)=>t(y,{children:e},$(`quickReply${o}`))))})]})}));export{v as TemplateWhatsApp};
//# sourceMappingURL=TemplateWhatsApp.js.map
